"use client"

import type { ReactNode } from "react"
import { MotionRoot } from "@/components/motion/framer"

/** Client boundary for server pages that render framer-motion descendants. */
export function MotionPage({ children }: { children: ReactNode }) {
  return <MotionRoot>{children}</MotionRoot>
}
